import { computed } from '@angular/core';
import { UrlService } from '../../../services/url/url.service';


export function getWidgetsLabels(urlService: UrlService) {

	const en = urlService.isEnglish;

	return {
		Disagree: computed(() => en() ? `Disagree` : `Desacuerdo`),
		Agree: computed(() => en() ? `Agree` : `De acuerdo`),

	};
}
